import 'js/calculators/calculators.js'
import Vue from 'vue'
import store from 'js/store/modules/calculators/savings/loan-calculator'
import calculator from './app'

new Vue({
  store,
  el: '#calculator',
  components: { calculator }
})
